import React, { FC } from 'react'

import ProductListHeader from './ProductListHeader'
import ProductItem from '@/checkout-instore-legacy/cart/containers/ProductItemContainer'
import { mapItemsToCartItems } from '@/checkout-instore-legacy/components/Commons/ProductSummary/utils'
import { ProductItemActions } from './ProductItem'
import {
  CartMessage,
  CartMessageType,
} from '@/checkout-instore-legacy/cart/message/types'
import { getCartMessagesByItem } from '@/checkout-instore-legacy/cart/message/utils'
import { useProductItemRefManagerContext } from '@/checkout-instore-legacy/cart/message/refManager/ProductItemRefManagerContext'

const MAX_PRODUCT_LIST_Z_INDEX = 99

interface ProductListProps {
  items: Item[]
  cartMessageMap: Record<string, Record<CartMessageType, CartMessage>>
  title: string
  listId: string
  // @ts-expect-error ts-migrate(2314) FIXME: Generic type 'RouterProps<Q, S>' requires 2 type a... Remove this comment to see the full error message
  router: RouterProps<Item>
}

type Props = ProductListProps & ProductItemActions

const ProductList: FC<Props> = ({
  items,
  cartMessageMap,
  router,
  title,
  onChangeSla,
  listId,
}) => {
  const mappedItems = mapItemsToCartItems(items)
  const productItemRefManager = useProductItemRefManagerContext()
  productItemRefManager?.allocItemRefs(items)

  const content = mappedItems.map(
    (item, index) =>
      item && (
        <div
          data-cy={`productlistitem-${index}`}
          id={`productlistitem-${item.index}`}
          className="relative mb3-ns mb0-s bb--muted-4-last-card-s"
          ref={productItemRefManager?.getItemRef(item)}
          style={{ zIndex: MAX_PRODUCT_LIST_Z_INDEX - index }}
          key={`${index}-${item.id || item.ean}`}
        >
          <ProductItem
            item={item}
            onChangeSla={onChangeSla}
            router={router}
            cartMessages={getCartMessagesByItem(cartMessageMap, item)}
          />
        </div>
      )
  )
  const dataCy = `product-list-${listId}`
  return (
    <section id="productlist" className="mt6-s mt7-ns" data-cy={dataCy}>
      <div id="productlist-items">
        {title && <ProductListHeader title={title} listId={listId} />}
        {content}
      </div>
    </section>
  )
}

export default ProductList
